export default __webpack_public_path__ + "assets/icon-home-selected.b49d3cfe.webp";